import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { FavoriteListing } from './types/FavoriteListing';

export interface FavoriteListingsResource {
  favorites: FavoriteListing[];
  count: number;
}

export interface Options {
  /**
   * @description comma-separated string with possible values: `listing`
   */
  expand?: string;
  withPhotos?: string;
}

export default (makeCall: MakeCall) => (userId: number, options?: Options) =>
  makeCall<FavoriteListingsResource>('GET', `/api/v2/listings/favorites`, {
    query: { userId, ...options },
  });
